import { Injectable, Injector } from '@angular/core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IBaseResponse } from '@carm/_utils/models';
import { IRoiResponse, IRoi, IRoiChangeResponse } from '../models/api';
import { mapRoiHeaderResponse } from '../models/api/roi.mapper';
@Injectable()
export class RoiService extends BaseApiService {
  constructor(protected injector: Injector) {
    super(injector);
  }

  get cadRoiUrl(): string {
    return `${this.endPointBP}/cad/roi`;
  }

  getRoi(roiUid: string): Observable<IRoiResponse> {
    const endPoint = `${this.cadRoiUrl}/${roiUid}`;
    return this.httpAuthGet<IRoiResponse>(endPoint);
  }

  deleteRoi(roiUid: string): Observable<IBaseResponse> {
    const endPoint = `${this.cadRoiUrl}/${roiUid}`;
    return this.httpAuthDelete<IBaseResponse>(endPoint);
  }

  getSubmittedHeaderAdjustments(guid: string): Observable<IRoi> {
    const endPoint = `${this.cadRoiUrl}/${guid}`;
    return this.httpAuthGet<IRoiResponse>(endPoint).pipe(
      map(response => mapRoiHeaderResponse(response))
    );
  }

  getSubmittedInvoiceAdjustments(guid: string): Observable<IRoiChangeResponse> {
    const endPoint = `${this.cadRoiUrl}/${guid}/invoices`;
    return this.httpAuthGet<IRoiChangeResponse>(endPoint);
  }

  getSubmittedCommodityAdjustments(
    invoiceUid: string
  ): Observable<IRoiChangeResponse> {
    const endPoint = `${this.cadRoiUrl}/invoices/${invoiceUid}/goods`;
    return this.httpAuthGet<IRoiChangeResponse>(endPoint);
  }
}
